import {
  isMediumDevice as isMediumDeviceSelector,
  isTabletDevice as isTabletDeviceSelector,
} from '@va/dashboard/selectors/ui';
import { isNil } from 'lodash';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';

export const useExpandableGridProps = () => {
  const isMediumDevice = useSelector((state) => isMediumDeviceSelector(state));
  const isTabletDevice = useSelector((state) => isTabletDeviceSelector(state));

  const getGridRow = (isExpanded: boolean, gridPosition?: number) => {
    if (!isExpanded || isMediumDevice || isNil(gridPosition)) return 'auto';
    if (isTabletDevice) {
      if (gridPosition % 2 !== 0) return `${Math.ceil(gridPosition / 2)}/span 2`;
      return 'auto';
    }
    return '1/3';
  };

  const getGridColumn = (isExpanded: boolean) => {
    if (!isExpanded) return 'auto';
    if (isMediumDevice) return 'auto/2';
    if (isTabletDevice) return 'auto/span 2';
    return '1/3';
  };

  const getCardHeight = useCallback((_isExpanded: boolean) => 'auto', []);

  return { getGridColumn, getGridRow, getCardHeight };
};
